function AboutUsTab() {
    return (
        <div className="abountUsTab">
            <div className="introductAboutUs">
                <div className="container">
                    <div className="row rowBox">
                        <div className="col-lg-6 col-12 col-md-6 colBox">
                            <div className="image">
                                <img className="img-fluid" src="/images/logoMandala.png" alt="" />
                            </div>

                        </div>
                        <div className="col-lg-6 col-12 col-md-6 colBox">
                            <h5 className="titleAboutUs">Ngành dịch vụ khách sạn Việt Nam đang bước sang một trang mới. Rất <span>Mandala</span>!</h5>
                            <p>Mandala  thuộc tập đoàn Apec group tự hào giới thiệu chuỗi khách sạn Mandala Hotels – một thương hiệu khách sạn hoàn toàn mới lạ, giúp định hình xu thế của ngành dịch vụ khách sạn tại Việt Nam.</p>
                        </div>
                    </div>
                    <div className="row rowBox">
                        <div className="col-lg-6 col-12 col-md-6 colBox">
                            <div className="image">
                                <p>Mandala Hotels được thiết kế dựa trên sự hiểu biết sâu sắc về khách hàng, tinh thần tôn trọng văn hóa bản địa và nỗ lực đi đầu trong giải pháp công nghệ. Không đơn thuần chỉ là nơi lưu trú, SOJO Hotels là sự trải nghiệm khác biệt của thiết kế đầy cảm hứng, dịch vụ thông minh và phong cách phục vụ chân thành và ấm áp.</p>
                                <img className="img-fluid imgSltyle imgDesktop" src="/images/img-aboutus.jpg" alt="" />
                            </div>

                        </div>
                        <div className="col-lg-6 col-12 col-md-6 colBox">
                            <img className="img-fluid imgDesktop" src="/images/img-brand.png" alt="" />
                            <div className="rowBoxMobile">
                                <div className="contentBox">
                                    <div className="colLeft">
                                        <p>Niềm tự hào thương
                                            hiệu khách sạn
                                            Việt Nam!</p>
                                        <img className="img-fluid" src="/images/img-aboutus.jpg" alt="" />
                                    </div>
                                    <div className="colRight">
                                        <img className="img-fluid" src="/images/img-brand.png" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div className="infomationAboutUs" style={{
                backgroundImage: `url("/images/bgrblue.jpg")`,
            }}>
                <div className="container">
                    <div className="titleContent">
                        <h5 className="title">MỘT THƯƠNG HIỆU TIÊN PHONG MANG TỚI KHÁI NIỆM CHƯA TỪNG CÓ: <br /> <span>"KHÁCH SẠN THUẬN ÍCH"</span></h5>
                        <p>SOJO Hotels đưa đến một dịch vụ lưu trú đặc biệt – kết hợp trải nghiệm công nghệ hiện đại đan xen dấu ấn địa phương thú vị với khát vọng mang lại sự ngạc nhiên thích thú cho du khách.  </p>
                    </div>
                    <div className="row">
                        <div className="col-lg-3 col-12 col-md-4 colBox">
                            <div className="itemBox textTnformation1">
                                <h6>Cá nhân hóa trải <br /> nghiệm khách hàng</h6>
                            </div>
                            <div className="itemBox textTnformation2">
                                <h6>Các tiện ích hiện đại,<br /> gần gũi</h6>
                            </div>
                        </div>
                        <div className="col-lg-6 col-12 col-md-4 colBox">
                            <img className="img-fluid" src="/images/information.png" alt="" />
                        </div>
                        <div className="col-lg-3 col-12 col-md-4 colBox">
                            <div className="itemBox textTnformation3">
                                <h6>Phong thái <br />
                                    trẻ trung, sôi nổi</h6>
                            </div>
                            <div className="itemBox textTnformation4">
                                <h6>Giải pháp thông minh, luôn đặt khách hàng làm trung tâm</h6>
                            </div>
                        </div>
                    </div>
                    <div className="titleContent"><p>Với phong cách chủ động táo bạo, SOJO Hotels luôn làm mới diện mạo ngành khách sạn Việt Nam ở bất kỳ nơi mà SOJO Hotels hiện hữu</p></div>
                </div>
            </div>
            <div className="criteria">
                <div className="container">
                    <div className="row rowBox">
                        <div className="col-lg-6 col-12 col-md-6 colBox">
                            <div className="imgStyle">
                                <img className="img-fluid imageVali" src="/images/ve-sojo-aboutus-vali.png" alt="" />
                            </div>
                            <div className="itemBox criteria3 " style={{
                                backgroundImage: `url("/images/criteria3.png")`,
                            }}>
                                <h5 className="titleAboutUs"> Thân thuộc với khách hàng</h5>
                                <p>Mandala Hotels luôn chào đón và xem du khách như một phần của gia đình, với sự chân thành và tôn trọng. Thái độ phục vụ thân thiện, tiện nghi thông minh dễ sử dụng và thiết kế không gian ấm cúng là cam kết của SOJO Hotels cho ngôi nhà phương xa đón chào mỗi du khách.</p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-12 col-md-6 colBox">
                            <div className="itemBox criteria1" style={{
                                backgroundImage: `url("/images/criteria1.png")`,
                            }}>
                                <h5 className="titleAboutUs">Người tiên phong mang tâm hồn <span>Việt</span> </h5>
                                <p>Tập trung vào những cải tiến lấy khách hàng làm trọng tâm, cùng sự am hiểu bản sắc địa phương và tư duy toàn cầu, SOJO Hotels mang đến mô hình khách sạn đặc biệt phá vỡ mọi quy tắc đã được biết đến. Độc đáo, hiểu biết và quyết đoán, SOJO Hotels định hình thương hiệu khách sạn tiên phong của Việt Nam.</p>
                            </div>
                            <div className="itemBox criteria2" style={{
                                backgroundImage: `url("/images/criteria2.png")`,
                            }}>
                                <h5 className="titleAboutUs">Thông minh theo cách mới </h5>
                                <p>SOJO Hotels phát triển dựa trên một triết lý đơn giản nhưng táo bạo, đó là thấu hiểu hành trình khách hàng dưới cách tiếp cận sáng tạo và liên tục cải tiến. Đến với SOJO Hotels, khách hàng sẽ tìm thấy nguồn cảm hứng để khám phá những trải nghiệm mới, thưởng thức hương vị mới và cảm nhận Việt Nam từ một góc nhìn mới.</p>
                            </div>
                            <div className="itemBox criteria4" style={{
                                backgroundImage: `url("/images/criteria4.png")`,
                            }}>
                                <h5 className="titleAboutUs"> Thúc đẩy cộng đồng</h5>
                                <p>Là thành viên địa phương nơi khách sạn đang tọa lạc, cùng với cách tiếp cận ngành dịch vụ khách sạn của người tiên phong, SOJO Hotels luôn nỗ lực giới thiệu văn hóa bản địa và tạo ra những giá trị mới cho khách hàng; từ đó góp phần thúc đẩy hình ảnh và chất lượng sống của cộng đồng địa phương</p>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    )
}
export default AboutUsTab;